import { getAmplitudeInstance } from '../amplitudeHelpers';
import InstallPromptLocation from '../enums/InstallPromptLocation';
import InstallPromptSource from '../enums/InstallPromptSource';
import InstallPromptType from '../enums/InstallPromptType';

type logInstallPromptDismissedParams = {
  install_prompt_location: InstallPromptLocation;
  install_prompt_source?: InstallPromptSource;
  install_prompt_type: InstallPromptType;
};

/**
 * User dismisses a prompt during a web session to install the app
 * @param params - Attributes to log with the amplitude event
 * @param params.install_prompt_location - Type of page the user was on when the prompt was triggered: home, park, trail, signup wall, etc.
 * @param params.install_prompt_source - Whether the prompt was served by Branch or natively built
 * @param params.install_prompt_type - Type of install prompt displayed to the user, depending on their journey: banner (home page, park page, trail page), interstitial (any signup wall)
 */
const logInstallPromptDismissed = (
  { install_prompt_location, install_prompt_source, install_prompt_type }: logInstallPromptDismissedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'install prompt dismissed',
    {
      'install prompt location': install_prompt_location,
      'install prompt source': install_prompt_source,
      'install prompt type': install_prompt_type
    },
    callback
  );
};

export default logInstallPromptDismissed;
